import { PageHeader } from '@/shared/components/PageHeader';
import { CalendarOff } from 'lucide-react';
import LeaveTypesStep from '../components/LeaveTypesStep';

export default function LeaveTypesPage() {
  return (
    <>
      <PageHeader
        title="Leave Types"
        subtitle="Manage leave types for the Leave Calendar"
        icon={<CalendarOff className="size-7 text-primary" />}
      />
      <LeaveTypesStep />
    </>
  );
}
